export default __webpack_public_path__ + "static/banner-8936b7ecd7932934192f7c21a5ace306.png";